export const PERMISSION_LEVEL = {
  NONE: 0,
  READ: 1,
  WRITE: 2,
} as const;
